module.exports = __webpack_public_path__ + "img/6f_r_tokiwa@2x.1ed40853.png";